// Simplified backgrounds - only 3 options
const backgrounds = {
  white: 'bg-white checkered-bg',
  cream: 'bg-cream checkered-bg',
  charcoal: 'bg-charcoal-dark text-chalk', // Solid background color
};

export default function Section({
  children,
  background = 'white',
  className = '',
  ...props
}) {
  return (
    <section
      className={`py-12 md:py-16 lg:py-20 ${backgrounds[background]} ${className}`}
      {...props}
    >
      <div className="container-custom">
        {children}
      </div>
    </section>
  );
}

export function SectionHeader({
  title,
  subtitle,
  centered = true,
  className = '',
  dark = false,
  titleColor = '', // New prop
}) {
  return (
    <div className={`mb-8 md:mb-10 ${centered ? 'text-center' : ''} ${className}`}>
      <h2 className={`text-2xl md:text-3xl font-headline font-semibold mb-3 uppercase tracking-wider ${
        titleColor ? titleColor : (dark ? 'text-chalk' : 'text-charcoal')
      }`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`max-w-xl mx-auto ${
          dark ? 'text-chalk/80' : 'text-gray-600'
        }`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
